module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/security/user/user.component.html
// module id = ./src/app/security/user/user.component.html
// module chunks = main